import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
import axios from 'axios';
var qs = require('qs');
const instance = axios.create({
    baseURL:'https://test.migee.net/index.php/',
    // test
  
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data) {
      data = qs.stringify(data);
      return data;
    }],
    withCredentials: true,
    crossDomain: true,
  });
//平台菜单
export const noticeindex= params=> {return addinstance().get(geturl(`/notice/index`),{params:params});}
export const createnotice= params => { return addinstance().post(geturl(`/notice/create`), params) };
export const updatenotice= params => { return addinstance().post(geturl(`/notice/update`), params) };
export const deletenotice= params => { return addinstance().post(geturl(`/notice/delete`), params) };
export const createserviceimg= params => { return instance.post(geturl(`/common/component/upload`), params) };



// WEBPACK FOOTER //
// ./src/api/noticeapi.js